export const s3AssetBasePath = "https://media.songfinch.com";